import { useFormikContext } from 'formik';
import ChanDoan from 'src/app/modules/component/generate-form/generate-custom-component/custom-component/ChanDoan';

const CustomComponent = ({ data }: any) => {
	const { setFieldValue, values } = useFormikContext<any>();

	const components: { [key: string]: any } = {
		chanDoan: (
			<ChanDoan
				rowClassName="ps-0"
				endRowClassName="pe-0"
				formName="additionalInfo"
				hasDiagnosisNonCoded={false}
				icd10Field="diagnosisCoded"
				onChange={(data) => {
					setFieldValue('visit.attributes', {
						...values?.visit?.attributes,
						...data,
					});
				}}
				fieldValue={values?.visit?.attributes}
				diagnosisList={data?.filteredICD10List}
			/>
		),
	};

	const DynamicContent = components[data?.componentName];

	return <>{DynamicContent}</>;
};

export default CustomComponent;
